import Work1 from '../../assets/work1.png'
import Work2 from '../../assets/work2.png'
import Work3 from '../../assets/work3.png'
import Work4 from '../../assets/work4.png'
import Work5 from '../../assets/work5.png'

export const projectsData = [
    {
        id: 1,
        image: Work1,
        title: "Kaju Resort Website",
        category: "web",
    },
    {
        id: 2,
        image: Work2,
        title: "Animal Rescue App",
        category: "app",
    },
    {
        id: 3,
        image: Work3,
        title: "Kaju Resort Website design",
        category: "design",
    },
    {
        id: 4,
        image: Work4,
        title: "Ecomzy.com E-Commerce",
        category: "web",
    },
    {
        id: 5,
        image: Work5,
        title: "Random Gif Generator",
        category: "Web",
    },
];

export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'Web',
    },
    {
        name: 'app',
    },
    {
        name: 'design',
    },
];